<template>
    
    <b-container
    class="mt-2"
    style="border: 2px solid #10486A; border-radius: 5px; background-color:#FFFFFF">

    <b-form @submit="submitToStripe">
        
        <b-row>
            <b-col>
                <p class="lead">{{message}}</p>
            </b-col>
        </b-row>

        <b-row>

            <b-col>
                <b-form-group
                    id="signup-subscriptionLevel-group"
                    label="Subscription Level"
                    label-for="subscriptionLevel"
                    description=""
                    valid-feedback="Looks good!"
                    invalid-feedback="This information is required.">
                        
                    <b-form-select 
                    id="subscriptionLevel"
                    v-model.trim="subscriptionLevel" 
                    :options="validSubscriptionLevels"
                    value-field="item"
                    text-field="name"
                    />

                    <b-form-text>
                        All subscription levels have the same features.  Patrons will have special privileges in the future.
                    </b-form-text>

                </b-form-group>
            </b-col>

        </b-row>
        
        <b-row>

            <b-col>

                <b-form-group
                    id="signup-loadDefaults-group"
                    label="Payment Details"
                    label-for="loadDefaults">
                        
                    <div id="card-element" ref="card-element"></div>

                    <b-form-text>
                        Your payment card information (securely processed using <a href="https://www.stripe.com">Stripe</a>).
                    </b-form-text>

                    <b-form-invalid-feedback :state="formValidation.cardValid">
                        {{formValidation.cardMessage}}
                    </b-form-invalid-feedback>

                </b-form-group>

            </b-col>

        </b-row>

        <b-row>
            <b-col>
                <b-button type="submit">Submit</b-button>
            </b-col>
        </b-row>

    </b-form>

    </b-container>

</template>

<script>

import genericOps from '../../mixins/genericOps'
import LocalStripeService from '../../services/LocalStripeService'

export default {
    mixins: [genericOps],
    data() {
        return {
            formValidation: {
                cardValid: null,
                cardMessage: null
            },
            message: null,
            stripeData: {
                stripe: null,
                apiToken: 'pk_test_toI3FCxLj9W47ouCvAWdEbaX00N55bSQoa',
                card: null,
                elements: null,

            },
            subscriptionLevel: null
        }
    },
    
    async mounted() {
        
   
        this.includeStripe('js.stripe.com/v3/', function() {
            this.configureStripe();
        }.bind(this) );
    },
    methods: {
        configureStripe(){
            
            if(typeof this.stripeData.stripe == 'undefined' || this.stripeData.stripe === null) {
                this.stripeData.stripe = Stripe( this.stripeData.apiToken );    
            }

            this.stripeData.elements = this.stripeData.stripe.elements();
            this.stripeData.card = this.stripeData.elements.create('card', {
                disabled: false, // This disables the input
                classes: {
                    base: 'form-control'
                }
            });

            this.stripeData.card.mount('#card-element');

            let that = this
            this.stripeData.card.addEventListener('change', function(event) {
                let displayError = that.$refs['card-errors']
                if (event.error) {
                    //displayError.textContent = 'ERROR: ' + event.error.message;
                    that.formValidation.cardValid = false
                    that.formValidation.cardMessage = event.error.message
                } else {
                    that.formValidation.cardValid = null
                    that.formValidation.cardMessage = null;
                }
            })

            

            

        },
        handleStripeCustomerActionRequired({subscription, invoice, priceId, paymentMethodId, isRetry}) {

            if(subscription && subscription.status === 'active') {
                return {subscription, priceId, paymentMethodId}
            }

            let paymentIntent = invoice ? invoice.payment_intent : subscription.latest_invoice.payment_intent

            if(paymentIntent.status === 'requires_action' ||
            (isRetry === true && paymentIntent.status === 'requires_payment_method')) {

                return this.stripeData.stripe.confirmCardPayment(paymentIntent.client_secret, {
                    payment_method: paymentMethodId
                }).then((result) => {
                    
                    if(result.error) {
                        
                        //console.log(JSON.stringify(result.error))
                        
                        this.formValidation.cardValid = false
                        this.formValidation.cardMessage = JSON.stringify(result.error.message)
                    
                    } else {
                        if(result.paymentIntent.status === 'succeeded') {
                            return {
                                priceId: priceId,
                                subscription: subscription,
                                invoice: invoice,
                                paymentMethodId: paymentMethodId
                            }
                        }
                    }
                }).catch((error) => {
                    this.formValidation.cardValid = false
                    this.formValidation.cardMessage = error
                })

            } else {
                return {subscription, priceId, paymentMethodId}
            }

        },
        includeStripe( URL, callback ){
            let documentTag = document, tag = 'script',
                object = documentTag.createElement(tag),
                scriptTag = documentTag.getElementsByTagName(tag)[0];
            object.src = '//' + URL;
            if (callback) { object.addEventListener('load', function (e) { callback(null, e); }, false); }
            scriptTag.parentNode.insertBefore(object, scriptTag);
        },
        handleStripeSubscriptionComplete({subscription, priceId, paymentMethodId}) {

            let paymentStatus = subscription.latest_invoice.payment_intent.status

            if(paymentStatus === 'succeeded') {
                let productId = subscription.plan.product
                let subscriptionId = subscription.id
                let customerId = subscription.customer

                this.message = paymentStatus +
                    'Customer ' + customerId + 
                    ', Subscription ' + subscriptionId +
                    ', Product ' + productId

            }
            

        },
        createStripeCustomer(nameFirst, nameLast, addressEmail) {
            
            //console.log('StripeDemo.createStripeCustomer STARTED')

            let customer = {
                //name: nameLast + ', ' + nameLast,
                description: 'Principal Task Customer',
                email: addressEmail
            }
            
            return LocalStripeService.createCustomer(customer, this.$store.getters.getUserToken).then((response) => {
                
                //console.log('StripeDemo.createStripeCustomer: Response from createCustomer = ' + JSON.stringify(response))
                
                return response
            
            }).then(result => {
                
                // result.customer.id is used to map back to the customer object
                // result.setupIntent.client_secret is used to create the payment method
                
                //console.log('StripeDemo.createStripeCustomer: result = ' + JSON.stringify(result))
                
                return result
            
            })
        },
        createStripePaymentMethod(cardElement, customerId, priceId) {
            
            // 20200606 -- ZWS -- Creates a PaymentMethod and displays an error
            // or invokes createStripeSubscription to subscribe the customer.

            return this.stripeData.stripe.createPaymentMethod({
                type: 'card',
                card: this.stripeData.card
            }).then((result) => {
            
                if(result.error) {
                    
                    //console.log('StripDemo.createStripePaymentMethod error: ' + result.error)
                    
                    this.formValidation.cardValid = false
                    this.formValidation.cardMessage = result.error
                
                } else {

                    //console.log('StripDemo.createStripePaymentMethod result: ' + JSON.stringify(result))
                    
                    let subscription = {
                        customerId: customerId,
                        paymentMethodId: result.paymentMethod.id,
                        priceId: priceId
                    }

                    //console.log('StripeDemo.createStripePaymentMethod creating subscription = ' + JSON.stringify(subscription))
                    
                    this.createStripeSubscription(subscription)

                }
            })
        },
        async createStripeSubscription({customerId, paymentMethodId, priceId}) {

            let subscription = {
                customer: customerId,
                default_payment_method: paymentMethodId,
                priceId: priceId
            }

            return LocalStripeService.subscribeCustomer(subscription, this.$store.getters.getUserToken).then((response) => {
            
                //console.log('LocalStripeService.subscribeCustomer returned '+ JSON.stringify(response))
                
                return response

            }).then((result) => {

                if (!result.data.result.successful) {
                
                    throw result.data.result.message
                
                }

                return result;

            }).then((result) => {

                return {
                    paymentMethodId: paymentMethodId,
                    priceId: priceId,
                    subscription: result.data.result.data,
                };

            }).then(this.handleStripeCustomerActionRequired)
            .then(this.handleStripeSubscriptionComplete)
            // .then((result) => {

            //     //console.log('Invoking handleStripeCustomerActionRequired with ' + JSON.stringify(result))
                
            //     return this.handleStripeCustomerActionRequired({
            //         subscription: result.subscription, 
            //         invoice: result.subscription.latest_invoice, 
            //         priceId: result.priceId, 
            //         paymentMethodId: result.paymentMethodId, 
            //         isRetry: false
            //     })

            // }).then((result) => {

            //     return this.checkStripePaymentStatus(result)

            // })
            .catch((error) => {
                
                this.formValidation.cardValid = false
                this.formValidation.cardMessage = error
            
            })

        },
        submitToStripe(evt) {
             
            evt.preventDefault()

            this.formValidation.cardValid = null
            this.formValidation.cardMessage = null

            //console.log('StripeDemo.submitToStripe STARTING')
             
            this.createStripeCustomer('Josiah', 'Bartlet', 'demo@principaltask.com').then((result) => {

                //console.log('Stripe Customer = ' + JSON.stringify(result))

                this.createStripePaymentMethod(this.stripeData.card, result.data.result.data.id, this.subscriptionLevel)

            })
             
             


        }
            
    }
    
}
</script>

<style>

</style>